require("./index.marko.css");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
        onAccordionEffect: function(target) {
          const $toggle = $((".card-header[data-target=\"#" + target) + "\"]");

          if ($toggle.attr("collapsed")) {
            return;
          }

          $toggle.closest(".accordion").children().each(function() {
            $(this).find(".card-header:not(.collapsed)").click();
          });
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Card-Accordion/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    marko_attrs0 = {
        "class": "col-lg-2"
      },
    marko_attrs1 = {
        "class": "col-5"
      },
    marko_attrs2 = {
        "class": "font-medium-4 text-ellipsis"
      },
    marko_attrs3 = {
        "class": "col-5 pr-3 d-flex align-items-center justify-content-end"
      },
    marko_attrs4 = {
        style: "margin-right:25px"
      },
    marko_attrs5 = {
        "class": "blue-grey-text",
        style: "margin-right:25px"
      },
    marko_attrs6 = {
        "class": "collapse-title"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("df8f89"),
    marko_node0 = marko_createElement("br", null, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "card-content border rounded mx-50",
        style: "margin-top:-5px;padding-top:5px"
      },
    marko_attrs8 = {
        "class": "card-body p-0"
      },
    marko_attrs9 = {
        "class": "card-content"
      },
    marko_attrs10 = {
        "class": "card-body py-0"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": marko_classValue(marko_classValue([
        "card mx-0",
        input.class
      ])),
      style: marko_styleValue(input.borderStyle ? "background:none" : "")
    }, "0", component, null, 1);

  out.be("div", {
      "class": marko_classValue(marko_classValue([
        "card-header collapse-header only-dark-bg-fade overflow-hidden collapsed",
        ((input.headerClass || "") + " ") + (input.noCollapseIcon ? "no-collapse-icon" : "")
      ])),
      "data-toggle": "collapse",
      "data-target": "#" + input.target,
      style: marko_styleValue(((("border-radius:" + (input.borderRadius || "10px")) + "!important;") + (input.noShadow ? "box-shadow:none!important" : "")) + ";")
    }, "1", component, null, 0, {
      onclick: __component.d("click", "onAccordionEffect", false, [
          input.target
        ])
    });

  if (input.type == "learning-path") {
    Row_tag({
        class: "collapse-title d-flex align-items-center",
        renderBody: function(out) {
          out.be("div", marko_attrs0, "3", component);

          Image_tag({
              alt: "Image",
              src: input.image,
              class: "img-fluid"
            }, out, __component, "4");

          out.ee();

          out.be("div", marko_attrs1, "5", component);

          out.be("h5", marko_attrs2, "6", component);

          Locale_tag({
              text: input.title
            }, out, __component, "7");

          out.ee();

          out.ee();

          if (input.caption) {
            out.be("div", marko_attrs3, "8", component);

            if (input.caption.label) {
              out.e("span", marko_attrs4, "9", component, 1)
                .t(input.caption.label, component);
            }

            if (input.caption.time) {
              out.e("span", marko_attrs5, "10", component, 1)
                .t(input.caption.time, component);
            }

            out.e("i", {
                "class": marko_classValue(marko_classValue([
                  "bx font-large-1",
                  input.caption.completed ? " bxs-check-circle green-text" : "bx-dots-horizontal-rounded"
                ]))
              }, "11", component, 0, 1);

            out.ee();
          }
        }
      }, out, __component, "2");
  } else {
    out.be("span", marko_attrs6, "12", component);

    if (input.icon) {
      Bx_tag({
          type: input.icon,
          class: "align-middle"
        }, out, __component, "13");
    }

    Locale_tag({
        class: "align-middle",
        text: input.title
      }, out, __component, "14");

    if (input.subtitle) {
      out.n(marko_node0, component);

      Locale_tag({
          class: "align-middle ml-1 px-50 font-small-3 text-muted",
          text: input.subtitle
        }, out, __component, "16");
    }

    out.ee();
  }

  out.ee();

  out.be("div", {
      id: input.target,
      "class": marko_classValue(marko_classValue([
        "collapse",
        input.contentClass
      ]))
    }, "17", component, null, 1);

  if (input.borderStyle) {
    out.be("div", marko_attrs7, "18", component);

    out.be("div", marko_attrs8, "19", component);

    if (input.content) {
      out.h(input.content, component);
    } else {
      marko_dynamicTag(out, input.renderBody, null, null, null, null, __component, "20");
    }

    out.ee();

    out.ee();
  } else {
    out.be("div", marko_attrs9, "21", component);

    out.be("div", marko_attrs10, "22", component);

    if (input.content) {
      out.h(input.content, component);
    } else {
      marko_dynamicTag(out, input.renderBody, null, null, null, null, __component, "23");
    }

    out.ee();

    out.ee();
  }

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
